<template>
  <!-- noneditable field -> readonly,
    hide system charges -> hideSystem,
    increment/decrement -> action -->
  <div ref="popover">
    <div v-if="hidePopOverReadOnly || noPopUp">
     <div class="row-text">
        <div class="gridrefvalue" :class="getTextClass">{{transporter}}</div>
      </div>
    </div>
    <Popover v-else :popper-class="smallCell ? 'popovercell-sm' : 'popovercell'"
      placement="bottom-end" v-model="visible"
      @after-enter="focusInput">
      <div class="popover-primary">
        <div class="popover-primary-body">
          <div class="focus-contain">
            <div class="focus-contain-div">
              <div class="focus-contain-div-list" v-if="visible">
                <div class="sec-text inputbox">
                  <svgicon name="expand"
                           style="float: left; height: inherit; padding: 9px 0; cursor: pointer; margin-left: 15px;"
                           width="15" height="12" :original="true"
                           @click="openCommentsDialog"/>
                  <input
                    class ="inputClass"
                    style="width: 60px"
                    :readonly="readOnly"
                    ref="inputRef"
                    min="0"
                    type="number"
                    :value="transporter"
                    @input="updateCharge($event)"
                    @keyup.esc="clearCell"
                    @keydown.38 = "preventDefault($event)"
                    @keydown.40 = "preventDefault($event)">
              </div>
              </div>
              <div class="focus-contain-div-list" v-if="discrepancy">
                <div class="sec-text italics">{{discrepancy}}</div>
                <span class="focus-contain-div-text">{{header.discrepancyType}}</span>
              </div>
              <div class="focus-contain-div-list" v-if="isShipperChargesFeatureEnabled && actualTransporter != null">
                <div class="sec-text italics">{{actualTransporter}}</div>
                <span class="focus-contain-div-text">{{ $t('TRANSPORTER_CHARGE') }}</span>
              </div>
              <div class="focus-contain-div-list" v-if="!isShipperChargesFeatureEnabled && transporter != null">
                <div class="sec-text italics">{{transporter}}</div>
                <span class="focus-contain-div-text">Transporter</span>
              </div>
              <div class="focus-contain-div-list" v-if="isShipperChargesFeatureEnabled && transporter != null">
                <div class="sec-text italics">{{transporter}}</div>
                <span class="focus-contain-div-text">{{ $t('SHIPPER_CHARGES') }}</span>
              </div>
              <div class="focus-contain-div-list" v-if="!hideSystem && system != null">
                <div class="sec-text italics">{{system}}</div>
                <span class="focus-contain-div-text">System</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-text" slot="reference" @click="show()">
        <div class="gridrefvalue" :class="getTextClass">{{transporter}}</div>
      </div>
    </Popover>
  </div>
</template>
<script>
import debounce from 'debounce';

export default {
  props: [
    'system',
    'transporter',
    'header',
    'discrepancy',
    'smallCell',
    'readOnly',
    'hideSystem',
    'hidePopOverReadOnly',
    'actualTransporter',
    'action',
    'isShipperChargesFeatureEnabled'],
  data() {
    return {
      visible: false,
      iscellbg: false,
      showInput: false,
    };
  },
  computed: {
    getTextClass() {
      if (!this.hideSystem) {
        if (this.transporter > this.system) {
          return 'sucesscolor';
        } else if (this.transporter < this.system) {
          return 'errorcolor';
        }
      }
      return '';
    },
    noPopUp() {
      return this.readOnly && (this.system == null && this.transporter == null);
    },
  },
  methods: {
    closePopUp() {
      this.visible = false;
    },
    formatNumber(num) {
      return Number(num.toFixed(2).replace(/\.00$/, ''));
    },
    // eslint-disable-next-line func-names
    updateCharge: debounce(function (event) {
      let editedValue = event.target.value;
      if (this.action === 'incrementOnly' && editedValue < this.system) {
        this.$errorMessage({ message: this.$getErr('DECREMENT_BLOCKING') });
        // setting to the last saved (in db) transporter value
        editedValue = this.actualTransporter;
      }
      if (this.action === 'decrementOnly' && editedValue > this.system) {
        this.$errorMessage({ message: this.$getErr('INCREMENT_BLOCKING') });
        // setting to the last saved (in db) transporter value
        editedValue = this.actualTransporter;
      }
      const chargeObj = {};
      chargeObj[this.header.column] = this.formatNumber(+editedValue);
      this.$emit('updateCharge', chargeObj);
    }, 300),
    closeCell() {
      this.visible = (this.visible) ? false : this.visible;
    },
    clearCell() {
      if (!this.readOnly) {
        const chargeObj = {};
        chargeObj[this.header.column] = this.actualTransporter;
        this.$emit('updateCharge', chargeObj);
      }
      this.closeCell();
    },
    focusInput() {
      this.$refs.inputRef && this.$refs.inputRef.focus();
    },
    show() {
      this.visible = true;
      this.smallCell && this.$emit('currentActiveElement', this.header.column);
    },
    preventDefault(e) {
      e.preventDefault();
    },
    openCommentsDialog() {
      const data = {
        system: this.system,
        transporter: this.transporter,
        charge: this.header.column,
        chargeLabel: this.header.label,
        actualValue: this.actualTransporter,
        action: this.action,
      };
      this.$emit('openCommentsDialog', data);
    },
  },
};
</script>
<style lang="scss" scoped>
.popover-outer {
  padding: 15px 10px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 1.2rem;
  text-align: right;
  &.popover-sm {
    padding: 6px 10px;
    .popover-sec {
      top: 2px;
      left: 1px;
      right: 1px;
      li {
        padding: 4px 0;
        .textfield {
          background-color: #fff;
          padding-right: 0;
        }
      }
    }
  }
  .popover-sec {
    background-color: #fff;
    margin: 0;
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    padding: 0 10px;
    list-style: none;
    z-index: 1;
    box-shadow: 1px 6px 9px 1px rgba(209, 208, 208, 0.5);
    li {
      padding: 8px 0 5px 0;
      font-family: "OpenSans-Regular";
      font-weight: normal;
      .textfield {
        width: 100%;
        height: 38px;
        padding-bottom: 8px;
        font-size: 12px;
        font-family: "OpenSans-Semibold";
        color: #008AFF;
        text-align: right;
        border: none;
        border-bottom: 1px solid #EEF2F4;
        &:focus {
          outline: none;
        }
      }
      .item-text {
        font-size: 1.2rem;
        font-style: italic;
        text-align: right;
        color: #737373;
      }
      small {
        display: block;
        font-size: 0.8rem;
        text-align: right;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }
  }
}
</style>
